<mat-card class="login-container">
  <mat-card-header>
    <img class="image-size" src="assets/themes/{{ themeService.currentLogo }}">
    <!--<h2>{{ 'nkn-motto' | translate }}</h2>-->
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="loginForm" (ngSubmit)="login()">
      <mat-form-field appearance="outline" class="full-width">
        <input matInput
               placeholder="{{ 'username' | translate }}"
               type="text"
               class="form-control"
               required
               autofocus
               formControlName="username" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput
               placeholder="{{ 'password' | translate }}"
               [type]="hide ? 'password' : 'text'"
               class="form-control"
               required
               formControlName="password" />
        <mat-icon matSuffix (click)="hide = !hide">
          {{
          hide ? 'visibility_off' : 'visibility'
          }}
        </mat-icon>
      </mat-form-field>
      <mat-card-actions class="login-button-pos">
        <div matTooltip="{{ 'forgot-password-cases' | translate }}"
             matTooltipClass="big-tooltip">
          <button mat-raised-button type="button" (click)="forgotPassword($event)">
            {{ 'forgot password' | translate }}
          </button>
        </div>
        <button mat-raised-button color="primary" type="submit" class="login">
          {{ 'login' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card-content>
</mat-card>
